import type { Locale } from "@chams-pay/contracts";
import { translate } from "@chams-pay/contracts";
import type { StudentSearchController } from "../core/use-students.js";
import { buildStudentListSummary } from "../core/student-list-summary.js";
import { Count } from "./figures.js";

export function StudentListSummary({
  locale,
  students,
}: {
  readonly locale: Locale;
  readonly students: StudentSearchController;
}) {
  const t = (key: Parameters<typeof translate>[1]) => translate(locale, key);
  const summary = buildStudentListSummary({
    activeCount: students.activeCount,
    visibleCount: students.items.length,
    query: students.query,
    filters: students.filters,
    filtersActive: students.filtersActive,
  });

  if (summary.enrolled) {
    return (
      <>
        <Count value={summary.count} /> {t("sp.enrolled")}
      </>
    );
  }

  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-1">
      <span>
        {locale === "ar" && `${t("sp.summaryCount")}: `}
        <Count value={summary.count} />
        {locale === "fr" &&
          ` ${t(summary.count === 1 ? "sp.summaryStudent" : "sp.summaryStudents")}`}
      </span>
      {summary.segments.map((segment, index) => (
        <span key={`${segment.labelKey ?? "value"}-${segment.valueKey ?? segment.value}-${index}`}>
          <span aria-hidden="true">· </span>
          {segment.labelKey && `${t(segment.labelKey)}: `}
          {segment.valueKey ? t(segment.valueKey) : <bdi dir="auto">{segment.value}</bdi>}
        </span>
      ))}
    </span>
  );
}
